import {
  buildRoute,
  fullClassName,
  Render,
  SmartLink,
  toggledClass,
} from '@techsharegov/react-ui';
import {
  useSubNavigation,
  NavConfigItem,
  Routes,
} from 'Navigation';
import { Fragment } from 'react';
import { useRouteMatch } from 'react-router-dom';

export const NavigationPillBar: React.FC<React.HTMLProps<HTMLDivElement>> = ({
  className,
  ...others
}) => {
  return (
    <div
      className={'pillbar__wrapper full-height ' + (className || '')}
      {...others}
    >
    </div>
  );
};

export type SecondaryNavigationPillBarProps = {
  parentRoute?: string;
  largeFont?: boolean;
};

export const SecondaryNavigationPillBar: React.FC<
  SecondaryNavigationPillBarProps
> = ({ parentRoute, largeFont }) => {
  const navConfig = useSubNavigation(parentRoute);
  const { url } = useRouteMatch();

  return (
    <Render condition={navConfig.length > 0}>
      <div className="flex-normal secondary-nav-pillbar">
        {navConfig.map((pill: NavConfigItem, index: number) => (
          <Fragment key={index}>
            <SmartLink
              to={
                pill.fullRoute
                  ? buildRoute(url, pill.fullRoute)
                  : Routes.Unauthorized
              }
              className={fullClassName(
                'flex-column full-height secondary-nav-pill',
                toggledClass('active', pill.active),
                toggledClass('header-size-small', largeFont)
              )}
            >
              <div className="flex-center">{pill.label}</div>
              <div className="navpill--underline bg-primary" />
            </SmartLink>
          </Fragment>
        ))}
      </div>
    </Render>
  );
};
